export default __webpack_public_path__ + "static/media/feature_4@3x.ea591237.png";